import React from 'react';
import { Flex, Loader } from '@marvelapp/ui';
import Page from '../Page';
export default function CenteredLoader() {
    return (React.createElement(Page, { title: "Loading" },
        React.createElement(Flex, { alignItems: "center", justifyContent: "center", minHeight: "100vh" },
            React.createElement(Loader, { size: 24 }))));
}
